import IntegratedAppOptions from 'integrated-app-embedder/IntegratedAppOptions';
import { FormMessages } from './FormsMessages';
export default class FormsAppOptions extends IntegratedAppOptions {
  setCreateFormAppInit() {
    this.options.push({
      key: FormMessages.CreateFormAppNavigation
    });
    return this;
  }
}